import { useEffect, useState } from "react";
import { Form, Tooltip, OverlayTrigger } from "react-bootstrap";
import { OPP_CONSTANTS } from "../../constants/OppContants";
import { FaCommentDots } from "react-icons/fa"; // Comment icon

const EditableComponent = ({
  focusKey,
  orderData,
  serialId,
  disabled,
  placeholder,
  handleOnChange,
  errorMessage,
  createFormRef,
  ignoreUnique,
}) => {
  const [updatedSerialId, setUpdatedSerialId] = useState(null);
  const [showTooltip, setShowTooltip] = useState(!!errorMessage);
  const [serialIdError, setSerialIdError] = useState(errorMessage);
  const [autoShowTooltip, setAutoShowTooltip] = useState(!!errorMessage);
  const [originalSerialId, setOriginalSerialId] = useState(orderData?.[focusKey]?.deviceNo);

  const currentSerialId = updatedSerialId ?? serialId;

  let triggerReason = null
  if (orderData?.[focusKey]?.triggerReason && currentSerialId === originalSerialId) {
    let triggerReasonData = JSON.parse(orderData?.[focusKey]?.triggerReason);
    triggerReason = OPP_CONSTANTS.messages.deviceInUse.replace("{reason}", triggerReasonData?.message).replace("{orders}", triggerReasonData?.existingOrders);
  }

  useEffect(() => {
    setShowTooltip(!!serialIdError);
  }, [serialIdError]);

  useEffect(() => {
    setSerialIdError(errorMessage);
  }, [errorMessage]);

  // Auto-hide tooltip after 5s, but allow hover after
  useEffect(() => {
    if (serialIdError) {
      setAutoShowTooltip(true);
      const timer = setTimeout(() => {
        setAutoShowTooltip(false);
      }, 5000);
      return () => clearTimeout(timer);
    } else {
      setAutoShowTooltip(false);
    }
  }, [serialIdError]);

  const handleChange = (e) => {
    const updatedValue = e.target.value;
    setUpdatedSerialId(updatedValue);

    let hasError = false;
    if (updatedValue !== serialId) {
      const deviceWithSerialId = Object.keys(orderData)?.filter((key) => {
        return (
          updatedValue !== null &&
          updatedValue !== "" &&
          orderData[key]?.deviceNo === updatedValue
        );
      });

      if (ignoreUnique || deviceWithSerialId?.length === 0) {
        handleOnChange(updatedValue);
      } else {
        hasError = true;
      }
    }
    setSerialIdError(hasError ? OPP_CONSTANTS.messages.invalidSerialId : null);
    handleOnChange(updatedValue, hasError ? OPP_CONSTANTS.messages.invalidSerialId : null);
  };

  const renderSerialIdTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <div
        dangerouslySetInnerHTML={{
          __html: serialIdError,
        }}
      />
    </Tooltip>
  );

  const renderTriggerTooltip = (props) => (
    <Tooltip id="trigger-tooltip" {...props}>
      {triggerReason}
    </Tooltip>
  );

  return (
    <div className="deviceid-input-container">
      {serialIdError ? (
        <OverlayTrigger
          show={autoShowTooltip ? true : undefined}
          placement="right"
          overlay={renderSerialIdTooltip}
        >
          <Form.Control
            ref={createFormRef}
            key={"index_input" + focusKey}
            onChange={handleChange}
            id="inlineFormInput"
            placeholder={placeholder ?? "Please Enter Serial Id"}
            value={updatedSerialId ? updatedSerialId : serialId}
            isInvalid={!!serialIdError}
            disabled={disabled}
          />
        </OverlayTrigger>
      ) : (
        <Form.Control
          ref={createFormRef}
          key={"index_input" + focusKey}
          onChange={handleChange}
          id="inlineFormInput"
          placeholder={placeholder ?? "Please Enter Serial Id"}
          value={updatedSerialId ? updatedSerialId : serialId}
          isInvalid={!!serialIdError}
          disabled={disabled}
        />
      )}

      {triggerReason && (
        <OverlayTrigger placement="top" overlay={renderTriggerTooltip}>
          <span className="trigger-reason-icon">
            <FaCommentDots size={16} />
          </span>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default EditableComponent;
